export default "__VITE_ASSET__WVs7xwIS__"